import { css } from 'styled-components';

export const sizes = {
	desktop: 1080,
	tablet: 768,
	phone: 576,
	small_phone: 321
};

export const above = Object.keys(sizes).reduce((acc, label) => {
	acc[label] = (...args) => css`
	  @media (min-width: ${sizes[label]}px) {
		${css(...args)}
	  }
	`;
	return acc;
}, {});

export const below = Object.keys(sizes).reduce((acc, label) => {
	acc[label] = (...args) => css`
	  @media (max-width: ${sizes[label] - 1}px) {
		${css(...args)}
	  }
	`;
	return acc;
}, {});


export default above;


// WEBPACK FOOTER //
// ./src/assets/css/media.js